"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createObjectDiff(actual, expected, propMatches) {
    var maxPropsToPrint = 6;
    var propDescriptors = propMatches.map(function (_a) {
        var prop = _a[0], matches = _a[1];
        return ({ prop: prop, matches: matches });
    });
    var trimmedStart = false;
    var trimmedEnd = false;
    if (propDescriptors.length > maxPropsToPrint) {
        var firstMismatchIndex = propDescriptors.findIndex(function (desc) { return !desc.matches; });
        if (firstMismatchIndex > 1) {
            propDescriptors = propDescriptors.slice(firstMismatchIndex);
            trimmedStart = true;
        }
    }
    if (propDescriptors.length > maxPropsToPrint) {
        var lastMismatchIndex = propDescriptors.map(function (desc) { return desc.matches; }).lastIndexOf(false);
        if (propDescriptors.length - lastMismatchIndex > 2) {
            propDescriptors = propDescriptors.slice(0, lastMismatchIndex + 1);
            trimmedEnd = true;
        }
    }
    if (propDescriptors.length > maxPropsToPrint) {
        var firstMismatchIndex = propDescriptors.findIndex(function (desc) { return !desc.matches; });
        var matchingDescriptorsStack = propDescriptors.filter(function (desc) { return desc.matches; });
        var mismatchingDescriptorsStack = propDescriptors.filter(function (desc) { return !desc.matches; });
        var trimmedDescriptors = propDescriptors.slice(0, firstMismatchIndex);
        while (trimmedDescriptors.length < maxPropsToPrint) {
            if (mismatchingDescriptorsStack.length > 0) {
                trimmedDescriptors.push(mismatchingDescriptorsStack.shift());
            }
            else {
                trimmedDescriptors.push(matchingDescriptorsStack.shift());
            }
        }
        propDescriptors = trimmedDescriptors;
    }
    var lines = propDescriptors.reduce(function (concatenated, descriptor) {
        var valuePrefix = Array.isArray(actual) ? "" : descriptor.prop + ": ";
        if (descriptor.matches) {
            return concatenated + ("    " + valuePrefix + previewValue(actual[descriptor.prop]) + ",\n");
        }
        else {
            return concatenated +
                (descriptor.prop in actual ? "-   " + valuePrefix + previewValue(actual[descriptor.prop]) + ",\n" : "") +
                (descriptor.prop in expected ? "+   " + valuePrefix + previewValue(expected[descriptor.prop]) + ",\n" : "");
        }
    }, "");
    var _a = Array.isArray(actual) ? ["[", "]"] : ["{", "}"], openingBrace = _a[0], closingBrace = _a[1];
    return "  " + openingBrace + "\n" + (trimmedStart ? "  ...\n" : "") + lines + (trimmedEnd ? "  ...\n" : "") + "  " + closingBrace;
}
function createObjectDiffMessage(message, actual, expected, path, propMatches) {
    var pathHeadline = path.length > 0 ? "  ." + describePath(path) + ":\n" : "";
    var objectDiff = createObjectDiff(actual, expected, propMatches);
    return message + "\n  - Actual, + Expected\n\n" + pathHeadline + objectDiff;
}
exports.createObjectDiffMessage = createObjectDiffMessage;
function describePath(path) {
    var description = String(path[0]);
    for (var _i = 0, _a = path.slice(1); _i < _a.length; _i++) {
        var fragment = _a[_i];
        description += typeof fragment === "number"
            ? "[" + fragment + "]"
            : "." + fragment;
    }
    return description;
}
exports.describePath = describePath;
function previewValue(value) {
    if (value === undefined) {
        return "undefined";
    }
    else if (value === null) {
        return "null";
    }
    else if (Array.isArray(value)) {
        return value.length === 0 ? "[]" : "[ … ]";
    }
    else if (Buffer.isBuffer(value)) {
        return "Buffer[" + value.length + "]";
    }
    else if (typeof value === "object") {
        return Object.keys(value).length === 0 ? "{ }" : "{ … }";
    }
    else if (typeof value === "symbol") {
        return value.toString();
    }
    else {
        var stringified = JSON.stringify(value);
        return stringified.length < 70 ? stringified : stringified.substr(0, 69) + "…";
    }
}
